namespace GeniuzPOS.ReportMasterData {
    export class Report_1502Columns {
        static columnsKey = 'ReportMasterData.Report_1502';
    }
}
